import React, { useEffect, useState } from "react";
import { Carousel, Modal, Button } from "react-bootstrap";
import "./HomePage.css";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const CsxHomePage = () => {
	const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
	const [documentUrls, setDocumentUrls] = useState([]);
	const [selectedDocument, setSelectedDocument] = useState(null);

	const fetchDocuments = async () => {
		try {
			const response = await fetch(
				`${process.env.REACT_APP_API_URL}/documents`
			);
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			const documents = await response.json();
			setDocumentUrls(documents);
		} catch (error) {
			console.error("Error fetching documents:", error);
		}
	};

	useEffect(() => {
		fetchDocuments();
	}, []);

	const handleThumbnailClick = (document) => {
		setSelectedDocument(document);
		setIsDocumentModalOpen(true);
	};

	const handleCloseDocumentModal = () => {
		setIsDocumentModalOpen(false);
		setSelectedDocument(null);
	};

	return (
		<div className="csx-home-page">
			<div className="document-carousel mb-5">
				<h3 className="carousel-header mt-2">Information Center</h3>
				<Carousel interval={4000}>
					{documentUrls.map((doc, index) => (
						<Carousel.Item
							key={index}
							onClick={() => handleThumbnailClick(doc)}
						>
							<div className="thumbnail-container">
								<img
									className="d-block w-100"
									src={doc.thumbnail}
									alt={`Slide ${index}`}
									style={{ height: "200px", objectFit: "contain" }}
								/>
							</div>
						</Carousel.Item>
					))}
				</Carousel>
			</div>

			<div className="content">
				<div className="trainer-dashboard-container">
					<h1 className="mb-5 text-danger trainer-dashboard-title">
						Tech Dev - CSX
					</h1>
				</div>
			</div>

			<Modal
				className="document-modal"
				show={isDocumentModalOpen}
				onHide={handleCloseDocumentModal}
				size="xl"
			>
				<Modal.Header closeButton>
					<Modal.Title>Document Viewer</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{selectedDocument && (
						<iframe
							src={selectedDocument.url}
							className="document-iframe"
							title="Document Viewer"
							sandbox="allow-scripts allow-same-origin"
						></iframe>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleCloseDocumentModal}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default CsxHomePage;
